(function () {

  angular
    .module('meanApp')
    .directive('nutriscore', nutriscore);

  function nutriscore () {
    return {
      restrict: 'EA',
      templateUrl: '/common/directives/nutriscore/nutriscore.template.html',
      replace: true,
      scope: {
        nutriscoreLetter : '@',
        size: '@'
      }
    };
  }

})();